var scriptsService = require("../../services/scripts.service");
var RecaptchaComponent = require("./recaptcha.component");

var RecaptchaFactoryService = function () {
    var onRecaptchaLoad = new Promise((resolve, reject) => {
        window.onRecaptchaLoad = function () {
            resolve();
        }
    });

    this.create = function($recaptchaContext, siteKey, callback) {
        return scriptsService.loadScript("https://www.recaptcha.net/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit")
            .then(() => onRecaptchaLoad)
            .then(function () {
                var recaptcha = new RecaptchaComponent();
                recaptcha.init($recaptchaContext, {siteKey: siteKey});
                recaptcha.on("recaptcha-validated", (gResponse) => callback(gResponse));

                return recaptcha;
            })
            .catch(console.log)
    }

    return this;
};

module.exports = new RecaptchaFactoryService();
